<template>
    <div class="templete_box">
        <div class="templete">
            <el-form ref="form" class="feedback_form" :model="form" label-width="100px" size="mini">
                <el-form-item label="手机号：" class="feedback_phone">
                    <el-input v-model="form.cat_phone" type="number" placeholder="手机号非必填"></el-input>
                </el-form-item>     
                <el-form-item label="反馈内容：">
                    <el-input type="textarea" :rows="9"  maxlength="300" show-word-limit v-model="form.content" placeholder="您留下的每条意见都将会帮助我们完善系统，期待您的反馈!(内容不少于5个字)"></el-input>
                </el-form-item>
                <el-form-item label="图片附件：" style="text-align: left;margin-top: 60px;">
                    <el-upload :action="oss.host" :data="upload_data" :multiple="true" list-type="picture-card" :on-exceed="handleExceed" :on-preview="handlePictureCardPreview" :before-remove="handleBeforeRemove" :on-remove="handleRemove" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :file-list="fileList" accept="image/gif, image/jpeg, image/png" :limit="3">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item  style="text-align: left;margin-top: 50px;">
                    <el-button type="primary" size="middle" @click="sumbitSuggestion">提交意见</el-button>
                </el-form-item>
                <el-dialog v-dialog-drag :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>    
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            form:{
                cat_phone: '',
                content: '',
                images: []
            },
            dialogImageUrl: '',
            dialogVisible: false,
            addressOss: '',

            oss : {
                host : "",
            },
            upload_data : {},
            imageLsit: [],
            file: {},
            fileList : [],
        }
    },
    methods: { 
        sumbitSuggestion(){
            window.console.log(this.form)
            let content = this.form.content
            if(content == ''){
                this.tip("请填写反馈内容",'warning')
                return
            }
            if(content.length <= 5){
                this.tip("反馈内容不能少于5个字",'warning')
                return
            }
            this.postFunc("erp/feedback.add", this.form, res=>{
                window.console.log(res)
                this.$alert('我们已收到您的反馈，感谢您的支持~', '提交成功', {
                    confirmButtonText: '我知道了',
                    callback: action => {
                        window.console.log(action)
                        if(action == 'confirm'){
                            this.form = {
                                cat_phone: '',
                                content: '',
                                images: []
                            }
                            this.fileList = []
                        }
                    }
                })
           })
          
        },
        handleExceed(files, fileList) {
            window.console.log(files, fileList)
            this.$message.warning('最多上传三张图片');
        }, 
        handleAvatarSuccess(res, file) {
            // if (this.form.images == "") {
            //     this.form.images = [];
            // }
            this.imageLsit.push(file);
            this.form.images.push(res.data.base_url);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleBeforeRemove(file, fileList){
            window.console.log(file);
            this.imageLsit = JSON.parse(JSON.stringify(fileList));
        },
        handleRemove(file, fileList) {
            let pos = "";
            this.imageLsit.forEach((item, index) => {
                if (file.uid == item.uid) {
                    pos = index;
                    return;
                }
            })
            this.form.images.splice(pos, 1);
            this.imageLsit = JSON.parse(JSON.stringify(fileList));
          
        },
        beforeAvatarUpload(file) {
            this.file = file;
            return this.getOss();
        },
        getOss(){
            let self = this;
            return new Promise((resolve, reject) =>{
                axios.post("https://cloud-api-dev.dwood365.com/tool/v1/oss.policy.get",{operate_code : "erp-woodn1"})
                .then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch((error)=>{
                        reject();
                    })
                }).catch((e) => {});
            },
    }
}
</script>

<style lang="scss" scoped>
.feedback_form{
    width: 600px;
    height: 100%;
    overflow: auto;
    margin-top: 20px;   
    .feedback_phone{
        width: 250px;
    }
}
.feedback_form /deep/ .el-input__inner:focus {
    border-color: #b21111;
}
.feedback_form /deep/ .el-input__inner{
    padding-right: 0;
}
.feedback_form /deep/ .el-textarea__inner:focus{
     border-color: #b21111;
}
.feedback_form /deep/ .el-upload--picture-card:hover,.feedback_form /deep/ .el-upload:focus {
    border-color: #b21111;
    color: #b21111;
}
.feedback_form /deep/ .el-button:focus, .feedback_form /deep/ .el-button:hover{
    color: #fff;
    border-color: #b21111;
    background-color: #b21111;
}
</style>